import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Layout from '../src/components/Layout';
import ThanksForParticipation from '../src/components/ThanksForParticipation/ThanksForParticipation';
import {
    getHeader,
    getFooter,
} from '../src/adapters/contentful.adapter';
import { GetEmailVerified } from '../src/helpers/StorageEvents';
import style from '../styles/userProfile/SurveyQuestions.scss';
import { buildContentfullImageUrl } from '../src/components/ReusableComponents/imageHelper';

class thanksForParticipation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoggedIn: false,
        };
    }

    componentDidMount = () => {
        if (window.sessionStorage.isUserLoggedIn && GetEmailVerified()) {
            this.setState({ isLoggedIn: window.sessionStorage.isUserLoggedIn });
        }
        if (!window.sessionStorage.isUserLoggedIn) {
            window.location.href = `${window.location.origin}/login`;
        }
        document.title = 'ウィスパーキャンペーン';
        window.scrollTo(0, 0);
    }

    render() {
        const { header, footer, pageInfo } = this.props;
        return (
            <div>{this.state.isLoggedIn
                ? (
                    <div>
                        <Layout header={header} footer={footer} pageInfo={pageInfo}>
                            <div className="content-wrapper">
                                <div className="whisper-jp-survey-form">
                                    <div className="frm-surveyQuestion container">
                                        <h1 className="form_head">ウィスパー新発売記念キャンペーン</h1>
                                        <div className="survey_Count">
                                            <span id="1">
                                                <img
                                                    className="img"
                                                    src={buildContentfullImageUrl("https://images.ctfassets.net/8g0fievzqg8k/2MSmg58oxdVWWLBXbTonQY/4021a09c83ba0e1564088eabad550173/surveyQuestion1.png")}
                                                    alt="Icon 1"
                                                />
                                            </span>
                                            <span id="2">
                                                <img
                                                    className="img"
                                                    src={buildContentfullImageUrl("https://images.ctfassets.net/8g0fievzqg8k/f1oH3lJYdsUOyUP1HpnM4/680e193a5ffc22abd30c762066ecd267/surveyQuestion2.png")}
                                                    alt="Icon 2"
                                                />
                                            </span>
                                            <span id="3">
                                                <img
                                                    className="img"
                                                    src={buildContentfullImageUrl("https://images.ctfassets.net/8g0fievzqg8k/LR6oCfOUjRHsTKMTRLrz5/9496870f6ac05e9ad51b86f848dee365/surveyQuestion3.png")}
                                                    alt="Icon 3"
                                                />
                                            </span>
                                            <span id="4" className="survey_sub">
                                                <img
                                                    className="img"
                                                    src={buildContentfullImageUrl("https://images.ctfassets.net/8g0fievzqg8k/F4II7ysslPuI3ajuS5JrY/60605543dd4aeedb0e9f85254af9f929/surveyQuestion4.png")}
                                                    alt="Icon 4"
                                                />
                                            </span>
                                        </div>

                                        <div className="sampling_campaign_container">
                                            <ThanksForParticipation />
                                        </div>
                                    </div>
                                </div>
                                <style jsx>{style}</style>
                            </div>
                        </Layout>
                    </div>
                ) : <div />}
            </div>
        );
    }
}

thanksForParticipation.getInitialProps = async () => {
    const header = await getHeader();
    const footer = await getFooter();

    return {
        header,
        footer,
        pageInfo: {
            breadcrumbsTitle: '参加ありがとう',
            url: '/参加ありがとう',
            title: 'ウィスパークラブの会員登録が完了いたしました。',
            description: 'ウィスパークラブの会員登録完了ページです。お得な情報や介護従事者向けを含む有益な情報をお届けします。',
            ogTitle: 'ウィスパークラブの会員登録が完了いたしました。',
            ogDescription: 'ウィスパークラブの会員登録完了ページです。お得な情報や介護従事者向けを含む有益な情報をお届けします。',
            canonicals: {
                breadcrumbsTitle: '参加ありがとう',
                url: '/参加ありがとう',
                items: [{ canonical: '/参加ありがとう' }],
            },
        },
    };
};

thanksForParticipation.propTypes = {
    footer: PropTypes.object,
    header: PropTypes.object,
    pageInfo: PropTypes.object,
};

export default thanksForParticipation;
